module.exports = __webpack_public_path__ + "assets/img/lithuania.ff3a808c.webp";